import * as actionTypes from './actionTypes';
import { default as Storage } from '../Storage';

const DEEP_LINK_STORAGE_KEY = 'deepLinkParams';

export const persistDeepLinkParams = () => {
  return async (_, getState) => {
    const { deepLinkParamaters } = getState();
    await Storage.set(DEEP_LINK_STORAGE_KEY, JSON.stringify(deepLinkParamaters))
  }
}

export const rehydrateDeepLinkParams = () => {
  return async (dispatch) => {
    let currentParams = await Storage.get(DEEP_LINK_STORAGE_KEY);
    await Storage.remove(DEEP_LINK_STORAGE_KEY);
    if (currentParams) {
      dispatch(addDeepLinkParams(JSON.parse(currentParams)));
    }
  }
}

export const addDeepLinkParams = (params) => {
  return {
    type: actionTypes.ADD_DEEP_LINK_PARAMS,
    payload: {
      params,
    },
  };
};

export const clearDeepLinkParams = (keys) => {
  return {
    type: actionTypes.REMOVE_DEEP_LINK_PARAM,
    payload: {
      keys,
    },
  }
}
